/**
 * @file localstorage.service.ts
 * @module to set common service for set and get value in localstorage
 * @author Nagendra
 */
import { Injectable } from '@angular/core';

@Injectable()
export class LocalstorageService {

  constructor() { }
  setData(key: string, value: any): void {
    if (typeof (value) == "object") {
      let data = JSON.stringify(value);
      localStorage.setItem(key, data);
    } else {
      localStorage.setItem(key, value);
    }
  }
  /** function for get data from localstorage*/
  getData(key: string) {
    try {
      var temp = JSON.parse(localStorage.getItem(key));
      return temp;
    } catch (e) {
      return localStorage.getItem(key) || "";
    }
  }
  /** function to remove data from localstorage*/
  removeData(key): void {
    localStorage.removeItem(key);
  }
}
